import clsx from 'clsx';
import React, { ReactElement } from 'react';
import { AiFillCheckCircle } from 'react-icons/ai';
import { BiSolidErrorCircle } from 'react-icons/bi';
import { FcProcess } from 'react-icons/fc';
import { FcCancel } from 'react-icons/fc';
import { GoAlertFill } from 'react-icons/go';
import { MdCancel } from 'react-icons/md';
import { PiClockCountdownBold } from 'react-icons/pi';

import { Tooltip } from '@/components/tooltip/tooltip';

import styles from './statusIcon.module.scss';

type StatusIconProps = {
  status?: string | null;
};

export function StatusIcon( { status }: StatusIconProps ): ReactElement {
  // Use 'system_issue' as fallback if no status
  const displayStatus = status || 'system_issue';
  const displayText = status ? status : 'System issue';

  const getStatusIcon = ( status: string ): ReactElement => {
    const statusLower = status.toLowerCase();

    switch ( statusLower ) {
      case 'queued':
        return <PiClockCountdownBold size={ 24 } />;
      case 'running':
        return <FcProcess size={ 24 } />;
      case 'complete':
      case 'completed':
        return <AiFillCheckCircle size={ 24 } color="#22c55e" />;
      case 'incomplete':
        return <GoAlertFill size={ 24 } color="#eab308" />;
      case 'failed':
        return <MdCancel size={ 24 } color="#ef4444" />;
      case 'cancelled':
        return <FcCancel size={ 24 } />;
      case 'system_issue':
      default:
        return <BiSolidErrorCircle size={ 24 } />;
    }
  };

  const capitalizeStatus = ( status: string ): string => {
    return status.charAt( 0 ).toUpperCase() + status.slice( 1 ).toLowerCase();
  };

  const tooltipContent = displayText === 'System issue' ? displayText : capitalizeStatus( displayText );

  return (
    <Tooltip content={ tooltipContent } position="top">
      <div
        className={ clsx( styles.status_icon ) }
        title={ displayText }
        data-testid="run-status"
        data-status={ displayStatus.toLowerCase() }
      >
        { getStatusIcon( displayStatus ) }
      </div>
    </Tooltip>
  );
}
